// extracted by mini-css-extract-plugin
export default {"container":"infoBoxes_container__va-cv","box":"infoBoxes_box__GnBMf","content__box":"infoBoxes_content__box__AEy62"};